import React, { useState, useEffect, FC } from 'react'
import { getGoogleCookieUserId } from 'lib/cookies'
import CarouselConnector, {
  ConnectorProps as CarouselProps,
} from '../../../connectors/CarouselABTest'
import Carousel from '../ABTest/Carousel'
import { getPluralizedCategory } from '../../../helpers'
import { GOOGLE } from '../../../helpers/constants'
import { getGoogleArtworks, clickArtwork } from '../helpers'
import { Section } from '../ABTest/styles'
import classNames from 'classnames'
import { getAlgoliaQueryIDFromLocalStorage } from 'lib/algolia/v2/helpers'

const MIN_ARTWORKS = 5
const LIST = 'you-may-also-like'

type RecommendedArtworksCarouselProps = CarouselProps & {
  shouldLoadComponent: boolean
  setShouldLoadComponent: React.Dispatch<React.SetStateAction<boolean>>
}

const RecommendedArtworksCarousel: FC<RecommendedArtworksCarouselProps> = (props) => {
  const [artworks, handleArtworks] = useState([])
  const {
    artworkId,
    category,
    relatedSeeMore,
    shouldLoadComponent,
    setShouldLoadComponent,
    algoliaSearchIndex,
    algoliaUserToken,
    userID,
  } = props
  const algoliaQueryIdFromLocalStorage = getAlgoliaQueryIDFromLocalStorage()
  const trimmedCategory = category.replace(/s$/, '').replace(/\sM/, 'm')
  const filter = trimmedCategory.length
    ? `tag="${trimmedCategory || 'Painting'}" filterOutOfStockItems`
    : ''
  useEffect(() => {
    const googleUserID = getGoogleCookieUserId()

    if (shouldLoadComponent) {
      getGoogleArtworks({
        artworkId,
        callBack: handleArtworks,
        category,
        visitorId: googleUserID,
        filter,
      })
    }
  }, [artworkId, shouldLoadComponent])

  if (!artworks || artworks.length < MIN_ARTWORKS) {
    return null
  }

  return (
    <Section data-section={LIST}>
      <h4
        className={classNames('defaultTypographyH4', 'defaultTextBold')}
        data-type='rec-carousel-title'
      >
        {getPluralizedCategory(category)} You May Also Like
      </h4>
      <Carousel
        artworks={artworks}
        clickArtwork={(ev) => {
          setShouldLoadComponent(false)
          clickArtwork(ev, algoliaSearchIndex, algoliaUserToken, userID)
        }}
        dataApi={GOOGLE}
        dataList={`${LIST}-pdp`}
        dataListId={`${LIST}-pdp`}
        dataListName={`${getPluralizedCategory(category)} You May Also Like`}
        seeMore={relatedSeeMore}
        algoliaSearchIndex={algoliaSearchIndex}
        algoliaUserToken={algoliaUserToken}
        algoliaQueryID={algoliaQueryIdFromLocalStorage}
        userID={userID}
      />
    </Section>
  )
}

export default CarouselConnector(RecommendedArtworksCarousel)
